const ServicesCategories = [
  { label: "Web", value: "Web" },
  { label: "Software", value: "Software" },
  { label: "Soporte web", value: "Soporte web" },
  { label: "SEO", value: "SEO" },
  { label: "UI/UX", value: "UI/UX" },
  { label: "BOT", value: "BOT" },
  { label: "Hosting y dominio", value: "Hosting y dominio" },
  { label: "Otros", value: "Otros" },
  { label: "Audiovisual", value: "Audiovisual" },
  { label: "SMM", value: "SMM" },
  { label: "ADS", value: "ADS" },
  { label: "Asesoria", value: "Asesoria" },
  { label: "SaaS", value: "SaaS" },
  { label: "Branding", value: "Branding" },
]

export default ServicesCategories;